// src/context/UValueContext.js
import { createContext, useContext, useMemo } from 'react';
import { useProjects } from './ProjectContext';
import { calcUValue } from '../utils/uvalueCalculations';

const SavedCtx = createContext([]);

export function UValueProvider({ children }) {
    const { activeProject } = useProjects();   // 👉 switches when user changes project

    const list = useMemo(() => {
        if (!activeProject?.uvalue) return [];

        return activeProject.uvalue
            .filter(c => c.layers?.length)                    // skip empty cards
            .map(c => {
                const U = calcUValue(
                    c.layers,
                    { Rsi: c.RsiVal ?? 0.13, Rse: c.RseVal ?? 0.04, ...c.allow }
                );
                return Number.isFinite(U)
                    ? { id: c.id, title: c.title || 'Konstruktion', U }
                    : null;
            })
            .filter(Boolean);                                 // drop incomplete ones
    }, [activeProject]);

    return <SavedCtx.Provider value={list}>{children}</SavedCtx.Provider>;
}

export const useSavedConstructions = () => useContext(SavedCtx);
